<template>
  <section class="max-w-screen-3xl mx-auto pl-6 lg:px-12">
    <Gallery :images="images" />
  </section>
</template>
<script setup lang="ts">
import type { GalleryImage } from '~/utils/types'

defineProps({
  images: {
    type: Array as PropType<GalleryImage[]>,
    required: true,
  },
})
</script>
